import { useI18N } from "@src/language/language-context";
import { RootState } from "@src/reducers/store";
import { SupportAgentTicket } from "@src/types/support";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { errorSnackbar } from "@src/cloud-connect/snackbars/entities/snackbar-launcher";
import { GetSupportTicketsResult } from "@src/cloud-connect/support/use-cases/get-support-tickets-with-language-use-case";
import { getMySupportTicketsWithLanguageUseCase } from "@src/cloud-connect/support/use-cases/get-my-support-tickets-with-language-use-case";

export const useGetUserTickets = (): [
  SupportAgentTicket[],
  React.Dispatch<React.SetStateAction<SupportAgentTicket[]>>,
] => {
  const i18n = useI18N();
  const authContext = useSelector(
    (state: RootState) => state.yourSlice.authContext,
  );
  const language = useSelector((state: RootState) => state.yourSlice.language);

  const [tickets, setTickets] = useState<SupportAgentTicket[]>([]);

  const texts = {
    errorFetchingTickets: i18n("modules.taskbar.errorFetchingTickets"),
    sseErrorText: i18n("modules.taskbar.sseErrorText"),
  };

  const fetchTickets = async () => {
    const response: GetSupportTicketsResult =
      await getMySupportTicketsWithLanguageUseCase(language);

    if (response.success && response.data) {
      setTickets(response.data.tickets);
    } else {
      console.error(response.error || texts.errorFetchingTickets);
      errorSnackbar(response.error || texts.errorFetchingTickets);
    }
  };

  const lastEvent = useSelector(
    (state: RootState) =>
      state.sseSlice.streams?.["service-support"]?.["lastEvent"],
  );
  const lastEventAt = useSelector(
    (state: RootState) =>
      state.sseSlice.streams?.["service-support"]?.["lastEventAt"],
  );

  useEffect(() => {
    if (
      lastEvent === "ticket_updated" ||
      lastEvent == "ticket_created" ||
      lastEvent == "comment_created"
    )
      fetchTickets();
  }, [lastEvent, lastEventAt]);

  useEffect(() => {
    if (!authContext || !authContext?.userId || !language) return;
    if (
      !authContext?.permissions?.includes("view-own-tickets") &&
      !authContext?.permissions?.includes("view-all-tickets")
    )
      return;

    // Initial fetch
    fetchTickets();
  }, [authContext, language]);

  return [tickets, setTickets];
};
